module.exports = __webpack_public_path__ + "static/rice-noodle-fish-629ab91904598aa6a197e310577b95a5.jpg";